module.exports = __webpack_public_path__ + "static/media/gift-test.c2e078bc.png";